import {
  Cell,
  Legend,
  Pie, PieChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';

// c360 grafik kabuğu — KPI ve Donut yardımcıları + TRY biçimleyici.
// Grafiklerin içeriği sayfaya özeldir; burada sadece ortak kabuk parçaları yaşar.

export function fmtTRY(v) {
  return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 }).format(v || 0);
}

/**
 * KPI kartı.
 *
 * `onClick` verilirse kart bir FİLTRE KISAYOLU olur (E-Belge Kontrol'ün 5 kartlı şeridi böyle
 * çalışır): <div> yerine <button> render edilir → klavye ile erişilebilir ve `active` ile basılı
 * durumu gösterir. onClick YOKSA davranış AYNEN eskisi gibidir (geriye dönük uyumlu — mevcut
 * çağıranların hiçbiri değişmedi).
 *
 * `tone`: 'crit' | 'warn' | undefined — sayının rengini verir (aciliyet).
 */
export function KpiCard({ label, value, hint, onClick, active = false, tone, title }) {
  const cls = [
    'c360-kpi',
    onClick ? 'c360-kpi--clickable' : '',
    active ? 'is-active' : '',
    tone ? `c360-kpi--${tone}` : '',
  ].filter(Boolean).join(' ');

  const body = (
    <>
      <div className="c360-kpi-label">{label}</div>
      <div className="c360-kpi-value">{value}</div>
      {hint && <div className="c360-kpi-hint">{hint}</div>}
    </>
  );

  if (!onClick) return <div className={cls}>{body}</div>;

  return (
    <button type="button" className={cls} onClick={onClick} aria-pressed={active} title={title}>
      {body}
    </button>
  );
}

export function DonutCard({ title, subtitle, data }) {
  const total = data.reduce((sum, d) => sum + d.value, 0);
  if (total === 0) {
    return (
      <div className="c360-chart-panel">
        <div className="c360-chart-panel-head">
          <span className="c360-chart-panel-title">{title}</span>
          {subtitle && <span className="c360-chart-panel-sub">{subtitle}</span>}
        </div>
        <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-secondary)', fontWeight: 700, fontSize: 12 }}>Veri yok</div>
      </div>
    );
  }
  return (
    <div className="c360-chart-panel">
      <div className="c360-chart-panel-head">
        <span className="c360-chart-panel-title">{title}</span>
        {subtitle && <span className="c360-chart-panel-sub">{subtitle}</span>}
      </div>
      <ResponsiveContainer width="100%" height={240}>
        <PieChart>
          <Pie data={data} dataKey="value" innerRadius={50} outerRadius={82} paddingAngle={2}>
            {data.map((d, i) => <Cell key={`cell-${i}`} fill={d.color || '#94a3b8'} />)}
          </Pie>
          <Tooltip formatter={(v, name) => [`${v} adet`, name]} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
